import { useEffect, useState } from "react";
import { updateProfile } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import AccountSidebar from "@/components/AccountSidebar";
import { BiometricSection } from "@/components/BiometricSection";
import { PaymentAccountsSection } from "@/components/PaymentAccountsSection";
import { Check } from "lucide-react";

export default function ParametresPage() {
  const { user, refresh, logout } = useAuth();
  const [form, setForm] = useState({ name: "", phone: "", city: "" });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", phone: user.phone || "", city: user.city || "" });
  }, [user]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateProfile(form);
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="max-w-7xl mx-auto px-6 py-10" data-testid="parametres-page">
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight">Parametres</h1>
      <p className="text-[var(--ink-soft)] mt-2">Gerez votre profil et votre compte Fodindin.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-6">
        <AccountSidebar />
        <div className="space-y-6">
        <section className="glass-card p-7 max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            {user?.picture ? (
              <img src={user.picture} className="w-16 h-16 rounded-2xl object-cover" alt="" />
            ) : (
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-400 text-white grid place-items-center text-xl font-bold">
                {(user?.name || user?.email || "?")[0]?.toUpperCase()}
              </div>
            )}
            <div>
              <div className="font-bold text-lg">{user?.name || "Utilisateur"}</div>
              <div className="text-sm text-[var(--ink-soft)]">{user?.email}</div>
            </div>
          </div>

          <form onSubmit={save} className="space-y-4" data-testid="parametres-form">
            <div>
              <label>Nom complet</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="param-name" />
            </div>
            <div>
              <label>Telephone</label>
              <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+225 ..." data-testid="param-phone" />
            </div>
            <div>
              <label>Ville</label>
              <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Abidjan" data-testid="param-city" />
            </div>

            <div className="flex items-center gap-3 pt-2">
              <button type="submit" disabled={saving} className="btn-primary inline-flex items-center gap-2" data-testid="param-save">
                {saving ? "Enregistrement..." : "Enregistrer"}
              </button>
              {saved && <span className="inline-flex items-center gap-1 text-sm text-green-600 font-semibold" data-testid="param-saved"><Check size={14} /> Profil mis a jour</span>}
            </div>
          </form>

          <div className="border-t border-[var(--line)] mt-8 pt-6">
            <div className="font-bold mb-2">Session</div>
            <button onClick={logout} className="btn-secondary !text-red-600 !border-red-200" data-testid="param-logout">Se deconnecter</button>
          </div>
        </section>

        <BiometricSection />
        <PaymentAccountsSection />
        </div>
      </div>
    </main>
  );
}
